import { render, staticRenderFns } from "./Myintegral.vue?vue&type=template&id=2c07981f&scoped=true&"
import script from "./Myintegral.vue?vue&type=script&lang=js&"
export * from "./Myintegral.vue?vue&type=script&lang=js&"
import style0 from "./Myintegral.vue?vue&type=style&index=0&id=2c07981f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07981f",
  null
  
)

export default component.exports